<template>
    <v-col>
        <div class="wrapper">
            <div class="wrap-filters primary">
                <v-row align="center">
                    <v-col cols="12" md="8" sm="5">
                        <h1>{{ driverLabel }}</h1>
                    </v-col>
                </v-row>
                <v-btn
                    color="secondary"
                    class="btn-add floating-btn"
                    elevation="0"
                    @click="showNewDriverForm = true"
                >
                    <v-icon size="18">mdi-plus</v-icon>
                    {{ $t("global.add") }}
                </v-btn>
            </div>

            <div class="wrap-datables">
                <v-row>
                    <v-col cols="12" md="6" sm="12">
                        <v-text-field
                            v-model="search"
                            :label="$t('global.search')"
                            append-icon="mdi-magnify"
                            dense
                            hide-details="auto"
                            light
                            outlined
                            single-line
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table
                            :footer-props="{
                                'items-per-page-options': [
                                    25, 50, 100, 500, -1,
                                ],
                            }"
                            :headers="headers"
                            :items="drivers"
                            :items-per-page="25"
                            :loading="loading"
                            :search="search"
                        >
                            <template #[`item.actions`]="{item}">
                                <v-btn
                                    class="reset ma-1"
                                    icon
                                    small
                                    dark
                                    @click="updateDriver(item.id)"
                                >
                                    <v-icon size="16">mdi-lock-reset</v-icon>
                                </v-btn>
                                <v-btn
                                    class="see ma-1"
                                    icon
                                    small
                                    dark
                                    @click="showConfirmDialog(item)"
                                >
                                    <v-icon size="16">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </div>
        </div>

        <new-driver
            :visible="showNewDriverForm"
            @close="showNewDriverForm = false"
            @newDriver="handleEvent"
        >
        </new-driver>
        <secret-code :driver="newDriver" :visible="showSecret"
                     @close="showSecret = false"/>

        <confirm-delete
            :message="$t('drivers.going_to_delete', [driver_to_delete.login])"
            :visible="confirm_dialog"
            @close="confirm_dialog = false"
            @validate="deleteDriver(driver_to_delete)"/>
    </v-col>
</template>

<script>
import NewDriver from "./new";
import SecretCode from "./secretCode";
import ConfirmDelete from "../../../components/dialogs/confirmDelete";
import Config from "../../../config.singleton";

export default {
    name: "Drivers",
    components: {
        NewDriver,
        SecretCode,
        ConfirmDelete
    },
    data() {
        return {
            search: "",
            drivers: [],
            headers: [
                {
                    text: this.$tc("drivers.login"),
                    align: "start",
                    sortable: true,
                    value: "login",
                },
                {
                    text: this.$tc("drivers.name"),
                    align: "start",
                    sortable: true,
                    value: "lastname",
                },
                {
                    text: this.$t("drivers.firstname"),
                    align: "start",
                    sortable: true,
                    value: "firstname",
                },
                {
                    text: this.$t("global.actions"),
                    align: "center",
                    sortable: false,
                    value: "actions",
                },
            ],
            showNewDriverForm: false,
            loading: false,
            newDriver: null,
            showSecret: false,
            resetLoading: false,
            confirm_dialog: false,
            driver_to_delete: {},
        };
    },
    computed: {
        driverLabel() {
            return Config.driver_label ?? $tc("drivers.drivers", 2)
        }
    },
    async mounted() {
        this.getDrivers()
    },
    methods: {
        handleEvent(driver) {
            this.getDrivers()
            this.showNewDriverForm = false
            this.showSecretDialog(driver)
        },
        async getDrivers() {
            try {
                this.loading = true
                await this.$api.drivers.all().then(({data: drivers}) => this.drivers = drivers.data)
                this.loading = false
            } catch (e) {
                this.loading = false
            }
        },
        async deleteDriver(id) {
            try {
                this.resetLoading = true
                await this.$api.drivers.delete(id)
                this.getDrivers()
                this.resetLoading = false
                this.confirm_dialog = false;
                this.driver_id_to_delete = null;
            } catch (e) {
                this.resetLoading = false
            }
        },
        async updateDriver(id) {
            const code = String(Math.floor(Math.random() * 9999))
            try {
                this.resetLoading = true
                const driver = (await this.$api.drivers.update(id, {
                    code,
                })).data.data
                this.showSecretDialog(driver)
                this.resetLoading = false
            } catch (e) {
                this.resetLoading = false
            }
        },
        showSecretDialog(driver) {
            this.newDriver = driver
            this.showSecret = true
        },
        showConfirmDialog(driver_to_delete) {
            this.confirm_dialog = true;
            this.driver_to_delete = driver_to_delete.id;
        }
    }
};
</script>
